/**
 * InviteLinkSheet - Mobile bottom sheet wrapper around InviteLinkCard
 * Opened from TripMenuSheet's "邀請連結" item (not a page navigation)
 * Design: tripways.pen node VxMro
 */

import Modal from '../common/Modal';
import InviteLinkCard from './InviteLinkCard';

interface InviteLinkSheetProps {
  isOpen: boolean;
  onClose: () => void;
  tripId: string;
}

export default function InviteLinkSheet({ isOpen, onClose, tripId }: InviteLinkSheetProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="邀請連結" variant="bottom-sheet">
      <div className="px-6 py-5">
        <InviteLinkCard tripId={tripId} />
      </div>
    </Modal>
  );
}
